import AnnotationsView from '@/components/AnnotationsView'
import { NextSeo } from 'next-seo'
import { getVideoSeo } from '@/utils/seo'
import { getServerSideProps } from '@/pages/videos/[id]'
import JsonLd from '@/components/JsonLd'
import { getVideoObjectSchema } from '@/utils/schemas'

export { getServerSideProps }

export default function Watch({ video }) {
  const seo = getVideoSeo({ video, isReadOnly: true })
  // Respect the owner's opt-out: keep the page reachable via its link but tell
  // search engines not to index it, and drop the VideoObject schema.
  const isPublic = video.public !== false

  return (
    <>
      <NextSeo {...seo} noindex={!isPublic} nofollow={!isPublic} />
      {isPublic && <JsonLd data={getVideoObjectSchema({ video })} />}
      <AnnotationsView {...{ video, isReadOnly: true }} />
    </>
  )
}
